export var hidden = {
  clip: 'rect(0 0 0 0)',
  height: '1px',
  width: '1px',
  position: 'fixed',
  zIndex: '-1'
};